
import { Vue, Options } from "vue-class-component";
import { SttHangingController } from "@/app/ui/controllers/SttHangingController";
import {
  HistoryFollowUpBooking,
  ActivitiesFollowUpBooking,
  HistoryFollowUpBookingFilterRequest
} from "@/domain/entities/HangingBooking";
import { debounce } from "lodash";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";
import { Pagination } from "@/domain/entities/Pagination";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import moment from "moment";

@Options({
  components: {
    PaginationV3
  }
})
class TabRiwayatFollowUpBooking extends Vue {
  isLoading = false;
  errorState = "";
  filterDate = new Date();
  filter = new HistoryFollowUpBookingFilterRequest();
  historyFollowUpBooking: HistoryFollowUpBooking[] = [];
  pagination = new Pagination(1, 10);

  setDateRange([startDate, endDate]: string[]) {
    this.filter = new HistoryFollowUpBookingFilterRequest({
      ...this.filter,
      page: 1,
      startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
      endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : ""
    });
    startDate && endDate && this.getFilter(this.filter);
  }

  get activityType() {
    return [
      { name: this.$t("dashboard.hangingBkd.historyPage.historyFollowUp.allActivities"), value: "" },
      { name: this.$t("dashboard.hangingBkd.historyPage.historyFollowUp.followUpPartnerClient"), value: "follow_up_partner_client" },
      { name: this.$t("dashboard.hangingBkd.historyPage.historyFollowUp.followUpUser"), value: "follow_up_username" },
      { name: this.$t("dashboard.hangingBkd.historyPage.historyFollowUp.searchWarehouse"), value: "follow_up_warehouse" }
    ];
  }

  activityTypeSelect = false;
  onOpenActivityType(value: boolean) {
    this.activityTypeSelect = value;
  }

  onSelectActivityType(_: string, value: string) {
    this.filter.activityType = value;
    this.onOpenActivityType(false);
    this.filter.page = 1;
    this.getFilter(this.filter);
  }

  get renderedData() {
    return this.historyFollowUpBooking.flatMap((obj) => obj.activities).length;
  }

  async mounted() {
    await this.getHistoryFollowUpBooking(
      new HistoryFollowUpBookingFilterRequest()
    );
  }

  getFilter = debounce(
    (filter: Partial<HistoryFollowUpBookingFilterRequest>) => {
      this.filter = new HistoryFollowUpBookingFilterRequest(filter);
      this.getHistoryFollowUpBooking(this.filter);
    },
    250
  );

  async getHistoryFollowUpBooking(params: HistoryFollowUpBookingFilterRequest) {
    try {
      this.errorState = "";
      this.isLoading = true;
      const res = await SttHangingController.getHistoryFollowUpBooking(params);
      this.historyFollowUpBooking = res.data;
      this.pagination = res.pagination;
    } catch (err) {
      this.errorState = err.response ? "server" : "internet";
    } finally {
      this.isLoading = false;
    }
  }

  async toPage(page: number) {
    if (page === this.pagination.page) {
      return;
    }
    this.pagination.page = page;
    this.filter = new HistoryFollowUpBookingFilterRequest({
      ...this.filter,
      page: page
    });
    await this.getHistoryFollowUpBooking(this.filter);
  }

  mapActivityType(activitie: ActivitiesFollowUpBooking) {
    const label: any = {
      "follow_up_partner_client": `${this.$t("dashboard.hangingBkd.historyPage.historyFollowUp.followUpTo")} ${activitie.followUp?.partnerName}`,
      "follow_up_username": `${this.$t("dashboard.hangingBkd.historyPage.historyFollowUp.followUpTo")} ${activitie.followUp?.username}`,
      "follow_up_warehouse": this.$t("dashboard.hangingBkd.historyPage.historyFollowUp.searchSttWarehouse")
    };

    const icon: any = {
      "follow_up_partner_client":
        activitie.followUp?.partnerType === "client"
          ? "ic_followup_client"
          : "ic_followup_console",
      "follow_up_username": "ic_pic",
      "follow_up_warehouse": "ic_search_hanging"
    };

    return {
      label: label[activitie.activityType] ?? "-",
      icon: icon[activitie.activityType] ?? "ic_pic"
    };
  }

  formatDateToString(date: string) {
    return formatDate(date);
  }
}
export default TabRiwayatFollowUpBooking;
